import React from 'react';

import skydiveController from '../../../main/assets/images/skydive/fpv-controller.webp';

export const CtrlPass = () => {
  return (
    <div className="skydive-ctrl-pass">
      <div className="skydive-ctrl-pass-container">
        <div className="skydive-ctrl-pass-polygon">
          <div className="skydive-ctrl-content-wrapper">
            <div className="skydive-ctrl-text-section">
              <div className="skydive-ctrl-title-section">
                <h2 className="skydive-ctrl-title">
                  <span className="skydive-ctrl-first-line">FPV.CTRL</span>
                  <span className="skydive-ctrl-second-line">PASS</span>
                </h2>
              </div>
              <p className="skydive-ctrl-description">
                Owning the ORQA FPV.Ctrl guarantees free lifetime access to all
                DLCs, providing a great cost-saving benefit, as long as the
                FPV.Ctrl is used as the controller in the simulator on Steam.
                Enjoy continuous, unrestricted content updates without
                additional costs.
              </p>
              <div className="dreamX__discover--button">
                <a
                  href="https://shop.orqafpv.com/products/orqa-orqa-fpv-ctrl-radio-controller"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn--primary btn--med"
                  onMouseDown={event => event.preventDefault()}
                >
                  buy now
                </a>
              </div>
            </div>
            <img
              src={skydiveController}
              alt="FPV Remote Controller for Drones"
              className="skydive-ctrl-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
